import React, { useEffect, useState } from 'react';
import { Alert, Button, FormControl, FormControlLabel, Grid, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, TextField, Typography, useMediaQuery } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { accountOptionArray, contributionTypeArray, pacFrequencyList, radioColorSx } from 'store/constant';
// import { ToastContainer, toast } from 'react-toastify';
import AddIcon from '@mui/icons-material/Add';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Stack } from '@mui/system';
import axiosInstance from 'custom-axios';
import { ToastContainer, toast } from 'react-toastify';
import NumberFormat from 'react-number-format';
import { useFullPageLoader } from 'hooks/useFullPageLoader';
import DeleteIcon from '@mui/icons-material/Delete';
import { showConfirmSweetAlert } from 'hooks/useSweetAlert';

const IncomeSweep = ({ incomeRef, accountTypeId, setAccountSweepIncomeData, formAccountData, userId, setFormAccountData, activeAccountStep, setActiveAccountStep, setParentActiveAccountTypeId, setActiveParentStep }) => {
    const today = new Date();
    const minDate = new Date();
    minDate.setDate(today.getDate() + 5);

    // Calculate the last date of the next month
    const maxDate = new Date(today.getFullYear(), today.getMonth() + 2, 0);
    const matchesMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const [filteredAccountDetails, setFilteredAccountDetails] = useState([]);
    const [transferDetails, setTransferDetails] = useState(formAccountData.transfer_details);
    const [selectedBankAccountNumber, setSelectedBankAccountNumber] = useState('');
    const [incomeSweepDetails, setIncomeSweepDetails] = useState([...formAccountData.income_sweep_details]);
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [hideFormData, setHideFormData] = useState(false)// make true because of income sweep not need now

    const {
        register,
        handleSubmit,
        setValue,
        trigger,
        formState: { errors }
    } = useFormContext();

    useEffect(() => {
        setValue('income_sweep_details', incomeSweepDetails);
    }, [incomeSweepDetails, setValue]);


    React.useImperativeHandle(incomeRef, () => ({
        triggerValidation: async () => {
            const isValid = await trigger();
            return isValid;
        }
    }));

    const fetchBankingData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-bank-info/${userId}`);

            if (response.data.length > 0) {
                setTransferDetails(response.data);
            }

        } catch (error) {
            // console.error(error.message);
        }
    }

    const fetchIncomeSweepData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-income-sweep-info/${userId}`);

            // setHideFormData(response.is_applicable)

            // setIncomeSweepDetails(registerAccountDetailsData);

            if (response.data) {
                setFormAccountData(prevFormData => ({
                    ...prevFormData,
                    ...response.data[0],
                }));

                let dataFilter = []

                if (response.data[0]) {
                    setIncomeSweepDetails(response.data);
                    dataFilter = response.data
                } else {
                    setIncomeSweepDetails([response.data]);
                    dataFilter = [response.data]
                }

                const defaultBankAccountNumber = dataFilter.income_sweep_investment_account_detail_id;

                if (defaultBankAccountNumber) {
                    setSelectedBankAccountNumber(defaultBankAccountNumber)
                }

                const filteredData = dataFilter.filter(
                    (detail) => detail.income_sweep_investment_account_detail_id == defaultBankAccountNumber
                );
                setFilteredAccountDetails(filteredData);

                setValue('income_sweep_start_date', response.data[0].income_sweep_start_date)
                setValue('income_sweep_frequency', response.data[0].income_sweep_frequency)
                setValue('income_sweep_account_option', response.data[0].income_sweep_account_option)
            }
        } catch (error) {
            // console.error(error.message);
        }
    }

    const fetchAccountTypeInfoData = async () => {
        try {
            const response = await axiosInstance.get(`api/get-user-account-type-info/${userId}`);

            if (response.data) {

                setFormAccountData(prevFormData => ({
                    ...prevFormData,
                    account_transfer: response.data.account_transfer,
                    account_eft: response.data.account_eft,
                    account_pac: response.data.account_pac,
                    account_swp: response.data.account_swp,
                    account_income_sweep: response.data.account_income_sweep,
                }));
            }
        } catch (error) {
            // console.error(error.message);
        }
    }

    const handleRoleBack = async () => {

        let endPoint = `api/change-form-step`;

        let modifiedChildStep = activeAccountStep - 1;

        // if (formAccountData.account_pac == 2 &&
        //     formAccountData.account_swp == 2 &&
        //     formAccountData.account_income_sweep == 2) {

        //     modifiedChildStep = 3;
        // } else {
        //     const stepsToCheck = [
        //         { stepIndex: 6, value: formAccountData.account_swp },
        //         { stepIndex: 5, value: formAccountData.account_pac },
        //         { stepIndex: 4, value: formAccountData.account_eft }
        //     ];

        //     // Find the highest-priority step where the value is 1
        //     for (const step of stepsToCheck) {
        //         if (step.value === 1) {
        //             modifiedChildStep = step.stepIndex;
        //             break;
        //         }
        //     }
        // }

        const submitData = { user_id: userId ? userId : 0, login_id: formAccountData.login_id, parent_step: 1, child_step: modifiedChildStep }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                setActiveAccountStep(modifiedChildStep);
            }

        } catch (error) {
            // console.error(error)
            toast.error('An error occurred when navigating back.')
        }
    };

    const handleTransferChange = (value, index, name) => {
        const updatedPolicies = [...incomeSweepDetails];
        updatedPolicies[0].income_sweep_plan_investment_instruction[index][name] = value;
        setIncomeSweepDetails(updatedPolicies);

        setAccountSweepIncomeData((prevData => ({
            ...prevData,
            ...updatedPolicies
        })))
    };

    const removeIncomeSweepInstruction = async (index, id, incomeSweepId) => {

        if (id) {

            const result = await showConfirmSweetAlert({
                title: 'Remove Item?',
                text: 'Are you sure you want to remove this?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, remove it!',
                cancelButtonText: 'No, cancel!',
            });

            if (result.isConfirmed) {


                showLoader()
                try {
                    const response = await axiosInstance.delete(`api/delete-income-sweep-instruction/${id}/${incomeSweepId}`);
                    hideLoader()

                    if (response.status == 200) {
                        toast.success(response.message);
                        fetchAllApi();
                    } else {
                        toast.error(response.message);
                    }

                } catch (error) {
                    toast.error(error.message);
                }
            }

        } else {
            const updatedTransferDetails = [...incomeSweepDetails];
            updatedTransferDetails[0].income_sweep_plan_investment_instruction.splice(index, 1);
            setIncomeSweepDetails(updatedTransferDetails);
        }
    }

    const addNewTemplate = () => {

        const updatedPolicies = [...incomeSweepDetails];
        updatedPolicies[0].income_sweep_plan_investment_instruction.push({
            id: '',
            income_sweep_pii_contribution_type: '',
            income_sweep_pii_fund_number: '',
            income_sweep_pii_fund_name: '',
            income_sweep_pii_gross_amount: ''
        });
        setIncomeSweepDetails(updatedPolicies);
    };

    const handleBankAccountChange = (event) => {

        const bankAccountNumber = event.target.value;
        setSelectedBankAccountNumber(bankAccountNumber);

        const filteredData = transferDetails.filter(
            (detail) => detail.bank_account_number === bankAccountNumber
        );
        setFilteredAccountDetails(filteredData);

        setAccountSweepIncomeData((prevData => ({
            ...prevData,
            bank_account_number: filteredData[0].bank_account_number,
            bank_name: filteredData[0].bank_name,
            bank_transit_number: filteredData[0].bank_transit_number,
            bank_institution_number: filteredData[0].bank_institution_number,
        })))
    };

    const submitForm = async () => {

        setFormAccountData(prevData => ({
            ...prevData,
            income_sweep_plan_investment_instruction: incomeSweepDetails
        }));

        let endPoint = `api/save-user-income-sweep-info`;

        // let modifiedChildStep = activeAccountStep;

        // if (formAccountData.account_income_sweep == 2) {
        //     modifiedChildStep = 7;
        // }
        const submitData = { ...incomeSweepDetails[0], ...filteredAccountDetails[0], login_id: formAccountData.login_id, accountTypeId: accountTypeId, user_id: userId ? userId : 0, parent_step: 2, child_step: 0 }

        try {
            const response = await axiosInstance.post(endPoint, submitData);

            if (response.status === 200) {
                // setActiveAccountStep(modifiedChildStep);
                setActiveAccountStep(0);
                setActiveParentStep(2)
            }

        } catch (error) {
            // console.error(error)
        } finally {
            hideLoader()
        }
    }


    const fetchAllApi = async () => {
        try {
            showLoader()
            await fetchIncomeSweepData()
            await fetchAccountTypeInfoData()
            await fetchBankingData()
            hideLoader()

        } catch (error) {
            hideLoader()
        }
    }


    useEffect(() => {
        fetchAllApi()
    }, [])


    return (
        <div className='container'>
            <form onSubmit={handleSubmit(submitForm)}>

                {hideFormData &&
                    <>
                        <div className='mt-3 width100'>
                            {incomeSweepDetails[0].income_sweep_plan_investment_instruction?.map((item, index) => (
                                <React.Fragment key={index}>

                                    {/* <Grid item xs={12}>
                                <Typography variant='h3' className='form-head-gray-title'>Income Sweep Instruction #{index + 1}</Typography>
                            </Grid> */}

                                    <Grid
                                        container
                                        direction="row"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        className='form-head-gray-title'
                                    >
                                        <Grid item>
                                            <Typography component={'h3'}>Income Sweep Instruction #{index + 1}</Typography>
                                        </Grid>

                                        <Grid item>
                                            <IconButton sx={{ p: "0 10px 0 0" }} disabled={index == 0} onClick={() => removeIncomeSweepInstruction(index, item.id, incomeSweepDetails[0].income_sweep_id)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2} className='p-4'>
                                        <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                            <label htmlFor="contribution_type" className='font15px'>Contribute Type</label>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <FormControl component="fieldset">
                                                <RadioGroup
                                                    row
                                                    id='contribution-type'
                                                    name='income_sweep_pii_contribution_type'
                                                    value={item.income_sweep_pii_contribution_type}
                                                    onChange={(e) => handleTransferChange(e.target.value, index, 'income_sweep_pii_contribution_type')}
                                                >
                                                    {contributionTypeArray.map((option) => (
                                                        <FormControlLabel
                                                            key={option.value}
                                                            value={option.value}
                                                            control={<Radio sx={radioColorSx} />}
                                                            label={option.label}
                                                        />
                                                    ))}
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={4}></Grid>

                                        <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                            <label htmlFor="income_sweep_pii_fund_number" className='font15px'>Fund Number</label>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <TextField
                                                label="Fund Number"
                                                fullWidth
                                                size="small"
                                                name='income_sweep_pii_fund_number'
                                                onChange={(e) => handleTransferChange(e.target.value, index, 'income_sweep_pii_fund_number')}
                                                value={item.income_sweep_pii_fund_number}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={4}></Grid>

                                        <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                            <label htmlFor="income_sweep_pii_fund_name" className='font15px'>Fund Name</label>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <TextField
                                                label="Fund Name"
                                                fullWidth
                                                size="small"
                                                name='income_sweep_pii_fund_name'
                                                onChange={(e) => handleTransferChange(e.target.value, index, 'income_sweep_pii_fund_name')}
                                                value={item.income_sweep_pii_fund_name}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={4}></Grid>

                                        <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                            <label htmlFor="income_sweep_pii_gross_amount" className='font15px'>Gross Amount</label>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <NumberFormat
                                                customInput={TextField}
                                                prefix="$"
                                                allowNegative={false}
                                                label="Gross Amount"
                                                name="income_sweep_pii_gross_amount"
                                                value={item.income_sweep_pii_gross_amount}
                                                variant="outlined"
                                                thousandSeparator={true}
                                                size='small'
                                                fullWidth
                                                onValueChange={(values) => {
                                                    handleTransferChange(values.value, index, 'income_sweep_pii_gross_amount');
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={4}></Grid>
                                    </Grid>
                                </React.Fragment>
                            ))}
                            <Button startIcon={<AddIcon />} onClick={() => addNewTemplate()}>
                                Add Income Sweep Instruction
                            </Button>
                        </div>

                        <Grid container spacing={2} className='p-4'>
                            <Grid item xs={12}>
                                <Typography variant='h3' className='form-head-gray-title'>Pre-Authorization Contribution</Typography>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                <label htmlFor="contribution_type" className='font15px'>Frequency</label>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl
                                    fullWidth
                                    size="small"
                                    error={Boolean(errors && errors['income_sweep_frequency'])}
                                >
                                    <InputLabel id="select-contact-application">Frequency</InputLabel>
                                    <Select
                                        labelId="select-contact-application"
                                        label="Province"
                                        value={incomeSweepDetails[0].income_sweep_frequency || ''}
                                        classes={{ select: "custom-select-label" }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } }
                                        }}
                                        onChange={(e) => {
                                            const updatedDetails = [...incomeSweepDetails];
                                            updatedDetails[0].income_sweep_frequency = e.target.value; // Update the frequency in the incomeSweepDetails array
                                            setIncomeSweepDetails(updatedDetails);
                                        }}
                                        inputProps={register('income_sweep_frequency', {
                                            required: true
                                        })}
                                    >
                                        {pacFrequencyList.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4}></Grid>

                            <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                <label htmlFor="pac-start-date" className='font15px'>Start Date</label>
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <Stack spacing={3}>
                                        <DesktopDatePicker
                                            label="Start Date"
                                            value={incomeSweepDetails[0].income_sweep_start_date || ''}
                                            id='pac-start-date'
                                            minDate={minDate}
                                            maxDate={maxDate}
                                            inputFormat="yyyy/MM/dd"
                                            onChange={(newValue) => {
                                                const updatedDetails = [...incomeSweepDetails];
                                                updatedDetails[0].income_sweep_start_date = newValue; // Update the start date in the incomeSweepDetails array
                                                setIncomeSweepDetails(updatedDetails);
                                                trigger('income_sweep_start_date');

                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    size="small"
                                                    // {...register('income_sweep_start_date')}

                                                    {...register('income_sweep_start_date', {
                                                        required: 'Start date is required',
                                                        /* validate: {
                                                            minDate: (value) =>
                                                                new Date(value) >= minDate || `Date must be after ${minDate.toISOString().split('T')[0]}`,
                                                            maxDate: (value) =>
                                                                new Date(value) <= maxDate || `Date must be before ${maxDate.toISOString().split('T')[0]}`
                                                        } */
                                                    })}
                                                />
                                            )}
                                        />
                                    </Stack>
                                </LocalizationProvider>

                            </Grid>
                            <Grid item xs={12} sm={12} md={4}></Grid>


                            <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                <label htmlFor="contribution_type" className='font15px'>Account Option</label>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                                <FormControl
                                    fullWidth
                                    size="small"
                                    error={Boolean(errors && errors['income_sweep_account_option'])}
                                >
                                    <InputLabel id="select-account-option">Account Option</InputLabel>
                                    <Select
                                        labelId="select-account-option"
                                        label="Account Option"
                                        value={incomeSweepDetails[0].income_sweep_account_option || ''}
                                        classes={{ select: "custom-select-label" }}
                                        MenuProps={{
                                            disableScrollLock: true,
                                            PaperProps: { sx: { maxHeight: 200 } }
                                        }}
                                        onChange={(e) => {
                                            const updatedDetails = [...incomeSweepDetails];
                                            updatedDetails[0].income_sweep_account_option = e.target.value; // Update the account option in the incomeSweepDetails array
                                            setIncomeSweepDetails(updatedDetails);
                                        }}
                                        inputProps={register('income_sweep_account_option', {
                                            required: true
                                        })}
                                    >
                                        {accountOptionArray.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </Grid>
                            <Grid item xs={12} sm={12} md={4}></Grid>

                            {(incomeSweepDetails[0].income_sweep_account_option == 1) &&
                                <>
                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="income_sweep_account-details" className='font15px'>Select Existing Investment Account</label>
                                    </Grid>

                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControl
                                            fullWidth
                                            size="small"
                                        // error={Boolean(errors && errors['income_sweep_investment_account_detail_id'])}
                                        >
                                            <InputLabel id="select-account-details">Investment Account</InputLabel>
                                            <Select
                                                labelId="select-account-details"
                                                label='Investment Account'
                                                value={incomeSweepDetails[0].income_sweep_investment_account_detail_id || ''}
                                                classes={{ select: "custom-select-label" }}
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: { sx: { maxHeight: 200 } }
                                                }}
                                                onChange={(e) => {
                                                    const updatedBankDetails = [...incomeSweepDetails];
                                                    updatedBankDetails[0].income_sweep_investment_account_detail_id = e.target.value; // Update the account option in the incomeSweepDetails array
                                                    setIncomeSweepDetails(updatedBankDetails);
                                                }}
                                                inputProps={register('income_sweep_investment_account_detail_id', {
                                                    required: true
                                                })}
                                            >
                                                {incomeSweepDetails[0].income_sweep_investment_account_details.map((option) => (
                                                    <MenuItem key={option.id} value={option.id}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>

                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>
                                </>
                            }

                            {/* -------------banking details ----------- */}
                            {(incomeSweepDetails[0].income_sweep_account_option == 2) &&
                                <>
                                    <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                        <label htmlFor="bank-name" className='font15px'>Account Number</label>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControl
                                            fullWidth
                                            size="small"
                                        >
                                            <InputLabel id="select-tpi-instruction_currency">Account Number</InputLabel>
                                            <Select
                                                labelId="select-tpi-instruction_currency"
                                                label="Account Number"
                                                value={selectedBankAccountNumber}
                                                classes={{ select: "custom-select-label" }}
                                                name='instruction_currency'
                                                MenuProps={{
                                                    disableScrollLock: true,
                                                    PaperProps: { sx: { maxHeight: 200 } }
                                                }}
                                                onChange={handleBankAccountChange}
                                            >
                                                {transferDetails.map((detail) => (
                                                    <MenuItem key={detail.id} value={detail.bank_account_number}>
                                                        {detail.bank_account_number}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}></Grid>

                                    {filteredAccountDetails?.map((item, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                                    <label htmlFor="bank-name" className='font15px'>Name Of Bank</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <TextField
                                                        label="Name Of Bank"
                                                        fullWidth
                                                        InputLabelProps={item.bank_name ? { shrink: true } : {}}
                                                        size="small"
                                                        name='bank_name'
                                                        disabled
                                                        value={item.bank_name}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={4}></Grid>


                                                <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                                    <label htmlFor="bank_transit_number" className='font15px'>Bank Transit Number</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={4}>
                                                    <TextField
                                                        label="Bank Transit Number"
                                                        fullWidth
                                                        size="small"
                                                        name='bank_transit_number'
                                                        disabled
                                                        InputLabelProps={item.bank_transit_number ? { shrink: true } : {}}
                                                        value={item.bank_transit_number}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={4}></Grid>


                                                <Grid item xs={12} sm={6} md={4} className={`align-content-center ${matchesMD ? '' : 'text-right'}`}>
                                                    <label htmlFor="bank_institution_number" className='font15px'>Institution Number</label>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={4}>

                                                    <TextField
                                                        label="Institution Number"
                                                        fullWidth
                                                        size="small"
                                                        name='bank_institution_number'
                                                        disabled
                                                        InputLabelProps={item.bank_institution_number ? { shrink: true } : {}}
                                                        value={item.bank_institution_number}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={4}></Grid>
                                            </React.Fragment>
                                        )
                                    })}
                                </>
                            }
                        </Grid>
                    </>
                }

                {!hideFormData &&
                    <div className='container'>
                        <Grid item spacing={2} className='p-4'>
                            <Alert
                                severity='info'
                                className='font14px cursor-pointer'
                                // onClick={handleClickExternalInvestmentOpen}
                            >
                                This client's account(s) are not applicable for Income Sweep.
                            </Alert>
                        </Grid>
                    </div>
                }
                <Grid item xs={12} sm={6} className='pt-3 text-center'>
                    <Button variant='contained' className='m-3 raintree-btn-green' onClick={handleRoleBack}>
                        Back
                    </Button>
                    <Button variant='contained' className='m-3 raintree-btn-green' type='submit'>
                        Next
                    </Button>
                </Grid>
            </form >
            {loader}
            < ToastContainer />
        </div >
    )
}

export default IncomeSweep;